module.exports = __webpack_public_path__ + "static/img/6.153d06b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/9/eng/6.png
// module id = IQO4
// module chunks = 0